import "./Gallery.scss";
import ImageCard from "../../components/ImageCard/ImageCard";
import { useEffect, useState, Fragment } from "react";
import { API_URL } from "../../utils/axios";
import axios from "axios";
import Loading from "../../components/Loading/Loading";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchAll = () => {
    axios
      .get(API_URL + "/gallery")
      .then((response) => {
        setImages(response.data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    fetchAll();
  }, [setImages]);

  const handleClick = (id) => {
    axios
      .get(API_URL + "/gallery/" + id + "/likes")
      .then((response) => {
        fetchAll();
      })
      .catch((error) => console.log(error));
  };
  return (
    <Fragment>
      {loading && <Loading />}
      {!loading && (
        <div className="gallery">
          <h1 className="gallery__title">GALLERY</h1>
          <div className="gallery__container">
            {images &&
              images.map((image) => (
                <ImageCard
                  key={image._id}
                  picture={image.picture}
                  id={image._id}
                  likes={image.likes}
                  comments={image.comments}
                  handleClick={handleClick}
                />
              ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Gallery;
